import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';

@Component({
  selector: 'app-confirm-message',
  templateUrl: './confirm-message.component.html',
  styleUrls: ['./confirm-message.component.scss']
})
export class ConfirmMessageComponent implements OnInit {
  public settings: Settings;

  title;
  message;
  okButtonText;
  cancelButtonText;
  okCallback;
  cancelCallback;


  hideCancelButton = false;

  constructor(public modalRef: BsModalRef, appSettings: AppSettings) {
    this.settings = appSettings.settings;
  }

  ngOnInit() {
    if (!this.cancelButtonText)
      this.hideCancelButton = true;
  }

  ok() {
    if (this.okCallback)
      this.okCallback();

    this.modalRef.hide();
  }

  cancel() {
    if (this.cancelCallback)
      this.cancelCallback();

    this.modalRef.hide();
  }
}
